import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { ClientVolume } from '../../../../types/dashboard.types';
import { useTheme } from '../../../theme/ThemeProvider';
import Card, { cardStyles } from '../../../components/ui/Card/Card';
import { tooltipStyle, tooltipText } from '../chartTheme';

// Barras en grises alternados: gris claro y casi blanco (intercalados)
const BAR_COLORS = ['#b9bdc3', '#eceef0'];

interface ClientAnalysisCardProps {
  data?: ClientVolume[];
}

const ClientAnalysisCard: React.FC<ClientAnalysisCardProps> = ({ data = [] }) => {
  const { resolvedTheme } = useTheme();

  const chartData = data.map((c) => ({
    name: c.client_name,
    loads: c.total_loads,
  }));

  return (
    <Card dark>
      <div className={cardStyles.header}>
        <h3 className={cardStyles.title}>Client Analysis</h3>
        <span className={cardStyles.subtitle} style={{ color: 'rgba(255,255,255,0.65)' }}>
          Top Clients by Load Volume
        </span>
      </div>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={chartData} margin={{ top: 8, right: 6, left: -20, bottom: 0 }}>
          <XAxis
            dataKey="name"
            tick={{ fill: 'rgba(255,255,255,0.7)', fontSize: 9.5 }}
            tickLine={false}
            axisLine={false}
            interval={0}
            height={60}
            angle={0}
          />
          <YAxis hide />
          <Tooltip
            cursor={{ fill: 'rgba(255,255,255,0.06)' }}
            contentStyle={tooltipStyle(resolvedTheme)}
            labelStyle={tooltipText(resolvedTheme)}
            itemStyle={tooltipText(resolvedTheme)}
          />
          <Bar dataKey="loads" radius={[6, 6, 0, 0]} maxBarSize={46}>
            {chartData.map((_, i) => (
              <Cell key={i} fill={BAR_COLORS[i % BAR_COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default ClientAnalysisCard;
